import {field} from "../../generic/tables";
import {t} from "i18next";
import EditModalChildren from "./EditModalChildren";
import {ENTITIES, getPermissions} from "../../../lib/utils/hooks/useRoleSystem";
import DirectoryTemplate from "../DirectoryTemplate";
import React from "react";

const EventCategory = (props) => <DirectoryTemplate
    fields={[
        field(t('directories.eventCategory.id'), true, "id"),
        field(t('directories.eventCategory.name'), true, "name"),
        field(t('directories.eventCategory.key'), false, "key"),
    ]}
    entityName={'event-categories'}
    EditModalChildren={EditModalChildren}
    deletable
    editable
    permissions={getPermissions(ENTITIES.EVENT_CATEGORIES)}
    {...props}
/>

export default EventCategory;